import create from 'zustand';
import generalApi from 'lib/api/general';

interface FetchGifParams {
  type: 'trending' | 'search';
  keyword: string;
  offset: number ;
}
interface IGifPickerStore {
  data: any[];
  totalCount: number;
  isLoading: boolean;
  fetchGif: (params: FetchGifParams) => void;
}

const gifPickerStore = create<IGifPickerStore>((set, get) => ({
  data: [],
  totalCount: 0,
  isLoading: false,
  fetchGif: async ({ type, keyword, offset = 0 }) => {
    set({ isLoading: true });
    const request = type === 'trending'
      ? generalApi.getTrendingGif(offset)
      : generalApi.getSearchGif(keyword, offset);

    request
      .then((res) => {
        const {
          data,
          meta: { error_code: error },
          pagination: { total_count: totalCount },
        } = res.data;

        if (!error) {
          const listData = offset > 0 ? [...get().data, ...data] : data;

          set({
            data: listData,
            totalCount,
            isLoading: false,
          });
        }
      })
      .catch(() => {});
  },
}));

export default gifPickerStore;
